import { http } from '@/http/axios';
import type { AuthUser, Gender } from '@/features/auth/types';
import { auth } from '@/lib/firebase';

export type MonthlyRevenue =
  | 'LESS_10K'
  | 'BETWEEN_10K_50K'
  | 'BETWEEN_50K_100K'
  | 'BETWEEN_100K_300K'
  | 'MORE_300K';

export type ExpertiseDomain = 'MONEY' | 'RELATIONSHIPS' | 'HEALTH';

export type UpdateAuthUserInput = {
  timezone?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  companyName?: string;
  gender?: Gender | string;
  country?: string;
  birthDate?: string;
  expertiseDomain?: ExpertiseDomain | string;
  expertiseSubdomain?: string;
  usedOtherWebinarTool?: string;
  monthlyRevenue?: MonthlyRevenue | string;
};

export type IntercomMessengerToken = {
  token: string;
  expiresAt: string;
};

export const authService = {
  me: () => http.get<AuthUser>('/auth/me').then((r) => r.data),
  intercomMessengerToken: (workspaceId?: number) =>
    http
      .get<IntercomMessengerToken>('/auth/intercom/messenger-token', {
        params: workspaceId == null ? undefined : { workspaceId },
      })
      .then((r) => r.data),
  logout: () => http.post('/auth/logout').then(() => undefined),
  updateAuthUser: (input: UpdateAuthUserInput) => http.put('/users', input).then(() => undefined),
  forgotPassword: (email: string) =>
    http.post('/auth/forgot-password', { auth, email }).then(() => undefined),
  updatePictureAuthUser: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return http
      .put('/users/picture', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => http.get<AuthUser>('/auth/me').then((r) => r.data));
  },
  deletePictureAuthUser: () =>
    http.delete('/users/picture').then(() => http.get<AuthUser>('/auth/me').then((r) => r.data)),
};
